import axios from "axios";
import * as actionTypes from "./ActionTypes";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

// get users payment history
export const userPaymentHistory = (search = "") => async (dispatch) => {
    dispatch({ type: actionTypes.PAYMENT_HISTORY_INIT });

    try {

        // get auth token
        const authToken = localStorage.getItem('authToken');
        let res = "";

        if (authToken) {
            res = await axios.get(`${BASE_URL}/payment/get-payment-records?search=${search}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
        }

        if (res.data.success === false) {
            dispatch({
                type: actionTypes.PAYMENT_HISTORY_FAIL,
                payload: "error",
            });
        } else {
            dispatch({
                type: actionTypes.PAYMENT_HISTORY_SUCCESS,
                payload: res.data,
            });
        }

        return res;

    } catch (error) {
        console.error("payment history error: ", error);
        dispatch({
            type: actionTypes.PAYMENT_HISTORY_FAIL,
            payload: "error",
        });
        throw error;
    }
};

// delete payment history
export const deleteUserPaymentHistory = (id) => async (dispatch) => {
    dispatch({ type: actionTypes.DELETE_PAYMENT_HISTORY_INIT });

    try {

        // get auth token
        const authToken = localStorage.getItem('authToken');
        let res = "";

        if (authToken) {
            res = await axios.delete(`${BASE_URL}/payment/${id}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
        }

        if (res.data.success === false) {
            dispatch({
                type: actionTypes.DELETE_PAYMENT_HISTORY_FAIL,
                payload: "error",
            });
        } else {
            dispatch({
                type: actionTypes.DELETE_PAYMENT_HISTORY_SUCCESS,
                payload: res.data,
            });
        }

        return res;

    } catch (error) {
        console.error("payment history delete error: ", error);
        dispatch({
            type: actionTypes.DELETE_PAYMENT_HISTORY_FAIL,
            payload: "error",
        });
        throw error;
    }
};

// create payment intent
export const createPaymentIntent = (profile_user_id) => async (dispatch) => {
    
    dispatch({ type: actionTypes.PYMENT_INTENT_INIT });

    try {

        // get auth token
        const authToken = localStorage.getItem('authToken');
        let res = "";

        if (authToken) {
            res = await axios.post(`${BASE_URL}/payment/create-payment-intent`, {profile_user_id}, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
        }

        if (res.data.success === false) {
            dispatch({
                type: actionTypes.PYMENT_INTENT_FAIL,
                payload: "error",
            });
        } else {
            dispatch({
                type: actionTypes.PYMENT_INTENT_SUCCESS,
                payload: res.data,
            });
        }

        return res;

    } catch (error) {
        console.error("payment history error: ", error);
        dispatch({
            type: actionTypes.PYMENT_INTENT_FAIL,
            payload: "error",
        });
        throw error;
    }
};